import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function InfluencerNavbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-lg py-4' : 'bg-transparent py-6'
    }`}>
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 group">
          <div className="w-24 h-24 rounded-full overflow-hidden border-2 border-amber-200">
            <img 
              src="https://static.readdy.ai/image/9b313db6312c9605d9f9e3f145d3e29c/32f3bc36bea2a3e696d7bc6c9c1538c4.jpeg" 
              alt="Bia Holmes"
              className="w-full h-full object-cover"
            />
          </div>
          <div>
            <div className="font-playfair text-xl font-bold text-gray-900">
              Carta do Eu Futuro
            </div>
            <div className="text-xs text-amber-600 font-semibold">
              Programa de Parceria
            </div>
          </div>
        </Link>

        {/* Navigation Links */}
        <div className="hidden md:flex items-center gap-8">
          <a 
            href="#beneficios" 
            className="text-gray-700 hover:text-amber-600 font-semibold transition-colors cursor-pointer"
          >
            Benefícios
          </a>
          <a 
            href="#como-funciona" 
            className="text-gray-700 hover:text-amber-600 font-semibold transition-colors cursor-pointer"
          >
            Como Funciona
          </a>
          <a 
            href="#depoimentos" 
            className="text-gray-700 hover:text-amber-600 font-semibold transition-colors cursor-pointer"
          >
            Parceiras
          </a>
          <a 
            href="#formulario"
            className="px-6 py-3 bg-gradient-to-r from-amber-600 to-amber-500 text-white rounded-full font-semibold hover:shadow-xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Candidatar-se
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden w-10 h-10 flex items-center justify-center">
          <i className="ri-menu-line text-2xl text-gray-900"></i>
        </button>
      </div>
    </nav>
  );
}